import { useEffect, useRef } from "react";
import { publish, subscribe, unsubscribe } from "util/custom-event";
import { useUnsavedChangesContext } from "ui/widgets/UnsavedChanges";
import { PaymentMethodProviderProps, usePaymentMethodContext } from "../PaymentMethodProvider";

const enum Events {
    ResetUnsavedCahnges = 'Events.ResetUnsavedCahnges'
};

export default function usePaymentMethodUnsavedChanges({ onChange }: Pick<PaymentMethodProviderProps, 'onChange'>) {
    const paymentMethodHandlers = usePaymentMethodContext();
    const paymentMethodHandlersRef = useRef(paymentMethodHandlers);
    paymentMethodHandlersRef.current = paymentMethodHandlers;

    const { checkUnsavedChanges } = useUnsavedChangesContext();

    useEffect(() => {
        const handleResetUnsavedChanges = () =>
            paymentMethodHandlersRef.current.reset();

        subscribe(Events.ResetUnsavedCahnges, handleResetUnsavedChanges);

        return () => unsubscribe(Events.ResetUnsavedCahnges, handleResetUnsavedChanges);
    }, []);

    const handleChange: PaymentMethodProviderProps['onChange'] = (event, expanded) =>
        checkUnsavedChanges({
            onCancel: () => Promise.reject(),
            onConfirm: () => publish(Events.ResetUnsavedCahnges, null)
        })
        .then(() => onChange!(event, expanded));

    return {
        onChange: handleChange
    };
};
